import { SESSION_STORAGE_KEYS } from 'frontend/constants';

/**
 * Obtiene el estado actual del caché desde sessionStorage
 * @returns {boolean} - Estado del caché (true por defecto si no está explícitamente establecido como false)
 */
export const getCacheStatus = () => {
  try {
    if (typeof window === 'undefined') {
      return true; // Valor por defecto en SSR
    }
    
    const cache = window.sessionStorage.getItem(SESSION_STORAGE_KEYS.CACHE_STATUS);

    // Si el cache está definido explícitamente como "false", devolvemos false
    if (cache === 'false') {
      return false;
    }

    // En cualquier otro caso (cache === 'true' o cache no existe), devolvemos true
    return true;
  } catch (error) {
    // Si hay cualquier error accediendo a sessionStorage, devolvemos true por defecto
    return true;
  }
};
